/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
// import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
// import MuiLink from "@mui/material/Link";
// @mui icons
// import FacebookIcon from "@mui/icons-material/Facebook";
// import GitHubIcon from "@mui/icons-material/GitHub";
// import GoogleIcon from "@mui/icons-material/Google";
// import HomeIcon from "@mui/icons-material/Home";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import logo from "assets/images/logo-ct.png";

// Styles
import { useDispatch, useSelector } from "react-redux";
import { loginHandler, loginSelector } from "store/login-slice";
import { googleLogin, login, studentgoogleLogin } from "services/auth-service";
import useLoading from "hooks/use-loading";
import useAlert from "hooks/use-alert";
import { FormControl, FormControlLabel, Radio } from "@mui/material";
import RadioGroup from "@mui/material/RadioGroup";
import classes from "./SignIn.module.css";
import BasicModal from "../../../components/MuiModal";
import useConfirm from "../../../hooks/use-confirm";

function Basic() {
  const { setShowLoader } = useLoading();
  const { createAlert } = useAlert();
  const { isConfirmed } = useConfirm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [rememberMe, setRememberMe] = useState(false);
  const [signupModal, setSignupModal] = useState(false);
  const [isTeacher, setIsTeacher] = useState(null);
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(true);

  const [password, setPassword] = useState("");
  const [isPasswordValid, setIsPasswordValid] = useState(true);

  const [loginError, setLoginError] = useState(false);
  const [loginErrorMessage, setLoginErrorMessage] = useState("");

  const queryParams = new URLSearchParams(window.location.search);
  const logoimg = queryParams.get("logoimg");
  const weburl = queryParams.get("domain");

  useEffect(() => {
    // eslint-disable-next-line no-undef
    document.title = "Sign In";
    // eslint-disable-next-line no-undef
    $('link[rel="canonical"]').prop("href", window.location.href);
  }, []);
  const confirmTeacher = async () => {
    const confirmed = await isConfirmed({
      title: "Are You Teacher?",
      description: "If Your Teacher then Tap on Yes Button",
    });
    if (confirmed) {
      navigate("/authentication/sign-up");
      setSignupModal(false);
    }
  };
  const confirmStudent = async () => {
    const confirmed = await isConfirmed({
      title: "Are You Student?",
      description: "If Your Student then Tap on Yes Button",
    });
    if (confirmed) {
      navigate("/authentication/student/sign-up");
      setSignupModal(false);
    }
  };
  // const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const onLoginWithGoogleSuccess = async (response) => {
    try {
      setShowLoader(true);
      const token = response.credential;

      const res = await googleLogin(token);
      if (res.status) {
        dispatch(
          loginHandler({
            token: res.token,
            userRole: res.data.user_role,
            name: res.data.name,
            phone: res.data.phone,
            email: res.data.email,
            isPlanExpired: String(res.plan_expired),
            accountId: res.data.account_id,
            apiKey: res.data.api_key,
            apiSecret: res.data.api_secret,
            tutorVerify: res.data.tutor_verify,
            isStudentPaid: String(res.is_student_paid),
            paymentGateway: res.payment_gateway ?? "",
            stripeVerified: res.stripe_verified === 0 ? "false" : "true",
            razorpayVerified: res.razorpay_verified === 0 ? "false" : "true",
            isManualStudent: res.data.userflag === 1 ? "true" : "false",
            isTutorMapped: String(res.isTutorMapped),
            isTrialUsed: res.data.isTrialUsed,
          })
        );
      } else {
        setLoginError(true);
        setLoginErrorMessage(res.message);
      }
    } catch (err) {
      // console.error(err.message);
      setLoginError(true);
      setLoginErrorMessage(err.message);
    }
    setShowLoader(false);
  };

  const studentLoginWithGoogleSuccess = async (response) => {
    try {
      setShowLoader(true);
      const token = response.credential;

      const res = await studentgoogleLogin(token);
      if (res.status) {
        dispatch(
          loginHandler({
            token: res.token,
            userRole: res.data.user_role,
            name: res.data.name,
            phone: res.data.phone,
            email: res.data.email,
            isPlanExpired: String(res.plan_expired),
            accountId: res.data.account_id,
            apiKey: res.data.api_key,
            apiSecret: res.data.api_secret,
            tutorVerify: res.data.tutor_verify,
            isManualStudent: res.data.userflag === 1 ? "true" : "false",
            isTutorMapped: String(res.isTutorMapped),
            paymentGateway: res.payment_gateway ?? "",
          })
        );
      } else {
        setLoginError(true);
        setLoginErrorMessage(res.message);
      }
    } catch (err) {
      // console.error(err.message);
      setLoginError(true);
      setLoginErrorMessage(err.message);
    }
    setShowLoader(false);
  };

  // const onLoginWithGoogleFailure = (response) => {
  const onLoginWithGoogleFailure = () => {
    createAlert("Login with google failed!", "error");
  };

  // const onSignoutSuccess = () => {};

  // Google authentication

  useEffect(() => {
    /* global google */
    const clientId = "334348115714-0q75fgdldm2ioc33j7akg4lvf8hr0hva.apps.googleusercontent.com";

    if (
      typeof google !== "undefined" &&
      typeof google.accounts !== "undefined" &&
      typeof google.accounts.id !== "undefined"
    ) {
      google.accounts.id.initialize({
        client_id: clientId,
        callback: onLoginWithGoogleSuccess,
      });

      google.accounts.id.renderButton(document.getElementById("signinTutor"), {
        theme: "outline",
        size: "large",
        text: "signin",
      });

      google.accounts.id.prompt();
    }

    /* global google1 */
    const google1 = window.google;
    if (
      typeof google1 !== "undefined" &&
      typeof google1.accounts !== "undefined" &&
      typeof google1.accounts.id !== "undefined"
    ) {
      google1.accounts.id.initialize({
        client_id: clientId,
        callback: studentLoginWithGoogleSuccess,
      });

      google1.accounts.id.renderButton(document.getElementById("signinStudent"), {
        theme: "outline",
        size: "large",
        text: "signin",
      });

      google1.accounts.id.prompt();
    }
  }, []);

  // END

  const { isLoggedIn } = useSelector(loginSelector);

  const signInHandler = async (e) => {
    try {
      e.preventDefault();
      // eslint-disable-next-line no-empty
    } catch (err) {}
    if (isEmailValid && isPasswordValid && password.length >= 0 && email.length >= 0) {
      try {
        setShowLoader(true);
        if (!isEmailValid) {
          setLoginError(true);
          setLoginErrorMessage("Please enter valid email");
          return false;
        }
        if (!isPasswordValid) {
          setLoginError(true);
          setLoginErrorMessage("Please enter valid password");
          return false;
        }

        const res = await login(email, password);
        if (res.status) {
          dispatch(
            loginHandler({
              token: res.token,
              userRole: res.data.user_role,
              name: res.data.name,
              email: res.data.email,
              isPlanExpired: String(res.plan_expired),
              phone: res.data.phone,
              accountId: res.data.account_id,
              apiKey: res.data.api_key,
              apiSecret: res.data.api_secret,
              tutorVerify: res.data.tutor_verify,
              isStudentPaid: String(res.is_student_paid),
              paymentGateway: res.payment_gateway ?? "",
              stripeVerified: res.stripe_verified === 0 ? "false" : "true",
              razorpayVerified: res.razorpay_verified === 0 ? "false" : "true",
              isManualStudent: res.data.userflag === 1 ? "true" : "false",
              isTutorMapped: String(res.isTutorMapped),
              isTrialUsed: res.data.isTrialUsed,
            })
          );
        } else {
          setLoginError(true);
          setLoginErrorMessage(res.message);
        }
      } catch (err) {
        setLoginError(true);
        setLoginErrorMessage(err.message);
      }
      setShowLoader(false);
    }
    return true;
  };

  useEffect(() => {
    if (isLoggedIn) {
      navigate("/dashboard");
    }
    // return () => {
    //   navigate('/');
    // }
  }, [isLoggedIn]);

  const emailChangeHandler = (e) => {
    setEmail(e.target.value);
    setIsEmailValid(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.target.value));
  };

  const passwordChangeHandler = (e) => {
    setPassword(e.target.value);
    setIsPasswordValid(e.target.value.length >= 6);
  };

  const navigateToHome = () => {
    if (weburl !== "" && weburl !== null) {
      document.location.href = weburl;
    } else {
      document.location.href = "https://tutorshell.com";
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <div
        style={{
          position: "absolute",
          top: "10px",
          left: "10px",
          cursor: "pointer",
        }}
        onClick={navigateToHome}
      >
        <img src={logoimg != null && logoimg !== "" ? logoimg : logo} width="100" alt="logo" />
      </div>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
          <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
            {/* <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <FacebookIcon color="inherit" />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <GitHubIcon color="inherit" />
              </MDTypography>
            </Grid> */}
            {/* <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <GoogleIcon color="inherit" />
              </MDTypography>
            </Grid> */}
          </Grid>
        </MDBox>
        <MDBox>
          <Grid container spacing={3} justifyContent="center">
            {typeof google !== "undefined" &&
              typeof google.accounts !== "undefined" &&
              typeof google.accounts.id !== "undefined" && (
                <>
                  <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
                    <MDTypography variant="button" color="text">
                      Sign in as Teacher
                    </MDTypography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    mt={0}
                    style={{ display: "flex", justifyContent: "center", paddingTop: "10px" }}
                  >
                    <div id="signinTutor">{}</div>
                  </Grid>
                  <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
                    <MDTypography variant="button" color="text">
                      Sign in as Student
                    </MDTypography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{ display: "flex", justifyContent: "center", paddingTop: "10px" }}
                  >
                    <div id="signinStudent">{}</div>
                  </Grid>
                </>
              )}
            {/* <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
              <GoogleLogin
                style={{ borderRadius: "10px !important", overflow: "hidden" }}
                clientId={clientId}
                buttonText="Sign in with Google as Student"
                onSuccess={studentLoginWithGoogleSuccess}
                onFailure={onLoginWithGoogleFailure}
                cookiePolicy="single_host_origin"
              />
            </Grid> */}
            {/* <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
              <GoogleLogin
                style={{ borderRadius: "10px !important", overflow: "hidden" }}
                clientId={clientId}
                buttonText="Sign in with Google as Teacher"
                onSuccess={onLoginWithGoogleSuccess}
                onFailure={onLoginWithGoogleFailure}
                cookiePolicy="single_host_origin"
              />
            </Grid> */}
          </Grid>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox>
            {/* error message */}
            {loginError && (
              <MDTypography variant="h6" color="error" align="center" style={{ fontSize: "13px" }}>
                {loginErrorMessage}
              </MDTypography>
            )}
          </MDBox>
          <form onSubmit={signInHandler}>
            <MDBox mb={2}>
              <MDInput
                error={!isEmailValid}
                className={`${!isEmailValid ? classes.error : ""}`}
                helperText={isEmailValid ? "" : "Please enter valid email"}
                onChange={emailChangeHandler}
                value={email}
                type="email"
                label="Email"
                fullWidth
              />
            </MDBox>
            <MDBox mb={0}>
              <MDInput
                error={!isPasswordValid}
                className={`${!isPasswordValid ? classes.error : ""}`}
                helperText={isPasswordValid ? "" : "Password length should be atleast 6"}
                onChange={passwordChangeHandler}
                value={password}
                type="password"
                label="Password"
                fullWidth
              />
            </MDBox>
            <MDBox textAlign="start">
              <MDTypography variant="button" color="text">
                <MDTypography
                  component={Link}
                  to="/authentication/forgot-password"
                  variant="button"
                  color="info"
                  fontWeight="light"
                >
                  Forgot Password ?
                </MDTypography>
              </MDTypography>
            </MDBox>
            {/* <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Remember me
              </MDTypography>
            </MDBox> */}
            <MDBox mt={3} mb={1}>
              <MDButton type="submit" variant="gradient" color="info" fullWidth>
                sign in
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Don&apos;t have an account?{" "}
                <MDTypography
                  // component={Link}
                  // to="/authentication/sign-up"
                  onClick={() => setSignupModal(true)}
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  {!logoimg && !weburl && "Sign up"}
                </MDTypography>
              </MDTypography>
              <BasicModal open={signupModal} onClose={() => setSignupModal(false)}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    onChange={(e) => {
                      setIsTeacher(e.target.value);
                      if (e.target.value === "1") {
                        confirmStudent();
                      } else {
                        confirmTeacher();
                      }
                    }}
                    value={isTeacher}
                  >
                    <FormControlLabel value={1} control={<Radio />} label="Sign Up as Student" />
                    <FormControlLabel value={2} control={<Radio />} label="Sign Up As Teacher" />
                  </RadioGroup>
                </FormControl>
              </BasicModal>
            </MDBox>
          </form>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
